import Ec2 from './Ec2Component';
import Rds from './RdsComponent';
import ElasticSearch from './ElasticSearchComponent';
import ElastiCache from './ElastiCacheComponent';
import Lambda from './LambdaComponent';

export default {
  Ec2,
  Rds,
  ElasticSearch,
  ElastiCache,
  Lambda
}



// WEBPACK FOOTER //
// ./src/components/aws/resources/index.js